import React, { useState } from "react";
import Home from "./page/Home";
import Detail from "./page/Detail";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { Navbar, Footer } from "flowbite-react";
import { GlobalProvider } from "./context/GlobalContext";

const App = () => {
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);

  const toggleNavbar = () => {
    setIsNavbarOpen(!isNavbarOpen);
  };

  return (
    <GlobalProvider>
      <BrowserRouter>
        <Navbar />
        <nav className="bg-white border-gray-200 px-2 sm:px-4 py-2.5 rounded dark:bg-gray-900">
          <div className="container flex flex-wrap justify-between items-center mx-auto">
            <a href="/" className="flex items-center">
              <img
                src="https://static.vecteezy.com/system/resources/previews/005/925/285/large_2x/initial-letter-k-logo-and-wings-symbol-wings-design-element-initial-letter-k-logo-icon-initial-logo-k-silhouette-vector.jpg"
                alt="KarirKu"
                className="h-12 w-12 mr-2"
              />
              <span className="self-center text-xl font-semibold whitespace-nowrap dark:text-white">
                KarirKu
              </span>
            </a>
            <button
              onClick={toggleNavbar}
              type="button"
              className="inline-flex items-center p-2 ml-3 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
              aria-controls="navbar-default"
              aria-expanded={isNavbarOpen}
            >
              <span className="sr-only">Open main menu</span>
              <svg
                className="w-6 h-6"
                aria-hidden="true"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
            <div
              className={`${
                isNavbarOpen ? "block" : "hidden"
              } w-full md:block md:w-auto`}
              id="navbar-default"
            >
              <ul className="flex flex-col mt-4 md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium">
                <li>
                  <Link
                    to="/"
                    className="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent dark:border-gray-700"
                    aria-current="page"
                  >
                    Beranda
                  </Link>
                </li>
                <li>
                  <a
                    href="/#job-vacancy-section"
                    className="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent dark:border-gray-700"
                  >
                    Lowongan
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="about/:jobId" element={<Detail />} />
        </Routes>
      </BrowserRouter>
      <Footer container className="mt-7">
        <div className="w-full text-center">
          <div className="w-full justify-between sm:flex sm:items-center sm:justify-between">
            <div className="flex items-center justify-center">
              <img
                src="https://static.vecteezy.com/system/resources/previews/005/925/285/large_2x/initial-letter-k-logo-and-wings-symbol-wings-design-element-initial-letter-k-logo-icon-initial-logo-k-silhouette-vector.jpg"
                alt="KarirKu"
                className="h-12 w-12 mr-2"
              />
              <span className="font-semibold text-xl">KarirKu</span>
            </div>
            <Footer.LinkGroup>
              <Footer.Link href="#">About</Footer.Link>
              <Footer.Link href="#">Privacy Policy</Footer.Link>
              <Footer.Link href="#">Contact</Footer.Link>
            </Footer.LinkGroup>
          </div>
          <Footer.Divider />
          <Footer.Copyright href="#" by="KarirKu" year={2023} />
        </div>
      </Footer>
    </GlobalProvider>
  );
};

export default App;
